"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');

var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);







var _common = require('shared/selectors/org/common');
var _features3 = require('shared/selectors/org/features');
var _relations = require('shared/selectors/user/relations');
var _blobject = require('shared/selectors/blobject');
var _peers = require('shared/selectors/peers');
var _phone = require('shared/services/phone');

const NONE = []
const NO_KEYWORDS = []
const NO_CHATS = []

/* Whether one of the caller's active orgs has KEYWORDS. Without one the apps
 * never ask for open requests and show none of the Requests UI. */
 const selectHasKeywordsOrg = _toolkit.createSelector.call(void 0, 
  _relations.selectMyActiveOrgKeysList,
  _common.selectOrgs,
  (orgKeys, orgs) => orgKeys.some(orgKey => _features3.orgHasFeature.call(void 0, orgs[orgKey], _features2.default.KEYWORDS)),
); exports.selectHasKeywordsOrg = selectHasKeywordsOrg

/* The caller's open requests, newest first; none without KEYWORDS. */
 const selectOpenRequests = (state) =>
  exports.selectHasKeywordsOrg.call(void 0, state) ? _nullishCoalesce(_optionalChain([state, 'access', _ => _.openRequests, 'optionalAccess', _2 => _2.list]), () => ( NONE)) : NONE; exports.selectOpenRequests = selectOpenRequests







const addKeyword = (map, key, keyword) => {
  const keywords = _nullishCoalesce(map.get(key), () => ( []))
  if (!keywords.includes(keyword)) map.set(key, [...keywords, keyword])
}

const selectRequestIndex = _toolkit.createSelector.call(void 0, exports.selectOpenRequests, (requests) => {
  const index = { keywordsByBKey: new Map(), keywordsByConversation: new Map(), byMessage: new Map() }
  requests.forEach(r => {
    addKeyword(index.keywordsByBKey, r.BKey, r.Keyword)
    addKeyword(index.keywordsByConversation, r.ConversationKey, r.Keyword)
    index.byMessage.set(r.MessageKey, r)
  })
  return index
})

/* The chats with an open request, newest request first: all of the caller's
 * (My Inbox), or one team's. The Requests list keeps this order. */
 const selectOpenRequestChatKeys = _toolkit.createSelector.call(void 0, 
  exports.selectOpenRequests,
  (_state, teamKey) => teamKey,
  (requests, teamKey) => {
    const newestFirst = requests
      .filter(r => !teamKey || r.TeamKey === teamKey)
      .sort((a, b) => +new Date(b.CreatedAt) - +new Date(a.CreatedAt))
    const keys = [...new Set(newestFirst.map(r => r.BKey))]
    return keys.length ? keys : NO_CHATS
  },
); exports.selectOpenRequestChatKeys = selectOpenRequestChatKeys

/* The Requests pill's number: chats with an open request (My Inbox's, or one
 * team's), however many requests each has. */
 const selectOpenRequestsCount = (state, teamKey) =>
  exports.selectOpenRequestChatKeys.call(void 0, state, teamKey).length; exports.selectOpenRequestsCount = selectOpenRequestsCount

/* The keywords of a chat's open requests, for its inbox row's chips. */
 const selectOpenRequestKeywordsByBKey = (state, bkey) =>
  _nullishCoalesce(selectRequestIndex(state).keywordsByBKey.get(bkey), () => ( NO_KEYWORDS)); exports.selectOpenRequestKeywordsByBKey = selectOpenRequestKeywordsByBKey

/* The keywords of a chat's open requests, for its header's chips. */
 const selectOpenRequestKeywordsByConversationKey = (
  state,
  conversationKey,
) => (conversationKey && selectRequestIndex(state).keywordsByConversation.get(conversationKey)) || NO_KEYWORDS; exports.selectOpenRequestKeywordsByConversationKey = selectOpenRequestKeywordsByConversationKey

/* The open request drawn as a card under this keyword line, if any. */
 const selectOpenRequestByMessageKey = (
  state,
  messageKey,
) => (messageKey ? selectRequestIndex(state).byMessage.get(messageKey) : undefined); exports.selectOpenRequestByMessageKey = selectOpenRequestByMessageKey

/* Who texted the keyword, for the card: the chat's patient's first name, or
 * their phone number for a new contact; else the chat's name. */
 const selectRequestSenderName = (state, bkey) => {
  const blobject = _blobject.selectBlobjectByKey.call(void 0, state, bkey)
  if (!blobject) return ''
  // SAFETY: the subscriber map is keyed by patient key.
  const patientKeys = Object.keys(blobject.PatientSubscribers || {}) 
  const patient = patientKeys.length === 1 ? _peers.selectPatientByKey.call(void 0, state, patientKeys[0]) : null
  return _optionalChain([patient, 'optionalAccess', _3 => _3.FirstName, 'optionalAccess', _4 => _4.trim, 'call', _5 => _5()])
    || (_optionalChain([patient, 'optionalAccess', _6 => _6.Phone]) ? _phone.formatPhoneNumber.call(void 0, patient.Phone) : '')
    || _optionalChain([blobject, 'access', _7 => _7.Name, 'optionalAccess', _8 => _8.trim, 'call', _9 => _9()])
    || ''
}; exports.selectRequestSenderName = selectRequestSenderName
